<template>
  <section id="who" class="section who-section">
    <h2 class="title">{{ $t('whoWill.title') }}</h2>
    <div class="title-line" :class="{ 'title-line-en': $i18n.locale === 'en' }"></div>
    <p class="subtitle">{{ $t('whoWill.subtitle') }}</p>
    <div class="divider-line"></div>
    <div class="cards">
      <div class="card" v-for="(item, index) in items" :key="index" :style="{ background: item.bg }">
        <div class="num" :style="{ background: item.color }">{{ index + 1 }}</div>
        <h3>{{ $t('whoWill.itemsHeader[' + index + ']') }}</h3>
        <p>{{ $t('whoWill.items[' + index + ']') }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhoWillTake',
  data() {
    return {
      items: [
        { color: '#2888ff', bg: 'rgba(114, 165, 231, 0.2)' },
        { color: '#2888ff', bg: 'rgba(114, 165, 231, 0.4)' },
        { color: '#2888ff', bg: 'rgba(114, 165, 231, 0.6)' },
        { color: '#2888ff', bg: 'rgba(114, 165, 231, 0.8)' },
        { color: '#2888ff', bg: 'rgba(114, 165, 231, 1)' }
      ]
    }
  }
}
</script>

<style scoped>
.who-section { padding: 72px 40px; background: url('../assets/classroom-bg@2x.png') center/cover no-repeat; text-align: center; position: relative; }
.who-section::before { content: ''; position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
.title { font-size: 28px; font-weight: 700; color: #1a1a1a; margin-bottom: 8px; position: relative; z-index: 1; }
.title-line { width: 300px; height: 10px; background: linear-gradient(to right, #2b7de9, transparent); margin: -18px auto 40px; }
.title-line-en { width: 400px; height: 10px; background: linear-gradient(to right, #2b7de9, transparent); margin: -18px auto 40px; }
.subtitle { font-size: 14px; color: #666; margin-bottom: 16px; position: relative; z-index: 1; }
.divider-line { width: 80%; max-width: 800px; height: 1px; background: #e0e0e0; margin: 0 auto 40px; position: relative; z-index: 1; }
.cards { display: flex; gap: 5px; max-width: 1100px; margin: 0 auto; justify-content: center; position: relative; z-index: 1; }
.card { flex: 1; max-width: 200px; border-radius: 1px; padding: 28px 16px 24px; text-align: center; transition: transform 0.2s; }
.card:hover { transform: translateY(-4px); }
.num {
  width: 36px; height: 36px; border-radius: 50%; color: #fff; font-size: 16px; font-weight: 700;
  display: flex; align-items: center; justify-content: center; margin: 0 auto 16px;
}
.card p { font-size: 13px; color: #333; line-height: 1.6; }
@media (max-width: 768px) { .cards { flex-wrap: wrap; } .card { max-width: 45%; } }
</style>
